module.exports = __webpack_public_path__ + "static/media/mum.205957a4.jpeg";